import gsap from "gsap";
import { bp, headerHeight, inner } from "../utils/variables";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ITransitionData } from "@barba/core";

import { initMblNav } from "./mbl-nav";
import { scrambleTextAnim } from "../components/scramble-anim";
import { runHeaderLinkAnims } from "../components/link";

export default function initHeader() {
    const cont = document.querySelector<HTMLElement>("main.main");
    if (!cont) return;

    initHeaderTriggers(cont);
    initMblNav();
}

export function refreshHeader(data: ITransitionData) {
    const cont = data.next.container;
    initHeaderTriggers(cont);
}

let headerTriggers: ScrollTrigger[] = [];
let logoWidth = 0;
function initHeaderTriggers(cont: HTMLElement) {
    const header = document.querySelector<HTMLElement>(".header");
    const footer = inner.w > bp.lg ? cont.querySelector<HTMLElement>(".footer--dsk") : cont.querySelector<HTMLElement>(".footer--mbl");
    if (!header || !footer) return;

    const logo = header.querySelector<HTMLElement>(".header__logo");
    if (!logo) return;

    resetHeader(header, logo);

    initHeaderLogo(header, logo, cont);
    initHeaderHide(header, footer);
    initColourSections(header, cont);
}

function resetHeader(header: HTMLElement, logo: HTMLElement) {
    headerTriggers.forEach(trigger => trigger.kill());
    header.classList.remove("header--hidden");
    header.classList.remove("header--scrolled");

    logo.setAttribute("data-text", "Mallard&Claret");
    logo.innerText = "Mallard&Claret";
    logoWidth = logo.clientWidth;
}

function initHeaderLogo(header: HTMLElement, logo: HTMLElement, cont: HTMLElement) {
    const hero = cont.querySelector(".hero");
    let headerScrolledPos = `top+=${headerHeight * 0.25} top`;
    if (hero) headerScrolledPos = `top+=${hero.clientHeight + headerHeight / 2} top`;

    headerTriggers.push(
        ScrollTrigger.create({
            trigger: header,
            start: "top-=10 top",
            end: headerScrolledPos,

            onLeave: () => toggleHeader(header, "hide", logo, logoWidth),
            onEnterBack: () => toggleHeader(header, "show", logo, logoWidth),
            onLeaveBack: () => toggleHeader(header, "hide", logo, logoWidth),
        })
    );
}

function initHeaderHide(header: HTMLElement, footer: HTMLElement) {
    headerTriggers.push(
        ScrollTrigger.create({
            trigger: footer,
            start: `top-=${headerHeight} top`,
            end: "bottom top",

            onEnter: () => header.classList.add("header--hidden"),
            onLeave: () => header.classList.remove("header--hidden"),
            onEnterBack: () => header.classList.add("header--hidden"),
            onLeaveBack: () => header.classList.remove("header--hidden"),
        })
    );
}

function initColourSections(header: HTMLElement, cont: HTMLElement) {
    const colourSections = Array.from(cont.querySelectorAll("[data-header-white], .bg--black"));

    const firstSection = cont.querySelector("section");
    if (firstSection && colourSections.includes(firstSection)) {
        header.classList.add("header--white");
    } else header.classList.remove("header--white");

    colourSections.forEach(section => {
        headerTriggers.push(
            ScrollTrigger.create({
                trigger: section,
                start: `top-=${headerHeight / 2} top`,
                end: `bottom-=${headerHeight / 2} top`,

                onEnter: () => header.classList.add("header--white"),
                onLeave: () => header.classList.remove("header--white"),
                onEnterBack: () => header.classList.add("header--white"),
                onLeaveBack: () => header.classList.remove("header--white"),
            })
        );
    });
}

function toggleHeader(header: HTMLElement, direction: string, logo: HTMLElement, logoWidth: number) {
    if (direction === "show") {
        header.classList.remove("header--scrolled");
        logo.setAttribute("data-text", "Mallard&Claret");
        scrambleTextAnim(logo, "Mallard&Claret", logoWidth);
    } else {
        header.classList.add("header--scrolled");
        logo.setAttribute("data-text", "M&C");
        scrambleTextAnim(logo, "M&C", logoWidth);
    }
}

export function headerIn() {
    const header = document.querySelector(".header");
    if (!header) return;

    gsap.to(header, {
        opacity: 1,
        duration: 1.2,
        ease: "expo.inOut",
        onComplete: () => {
            gsap.set(header, { pointerEvents: "all" });
        },
    });

    setTimeout(runHeaderLinkAnims, 600);
}
